import { Sort } from '@angular/material/sort';
import { SimpleCertificate } from 'app/library/certificate/models/simple-certificate.model';
import { ExtendedAttributeFilterInterface } from 'app/library/all-users/interfaces/extended-attribute-filer.interface';
import { IModuleUserDateRangeFilters } from 'app/library/module-user/interfaces/module-user-date-range-filters.interface';
import { ModuleUserExtended } from 'app/library/module-user/models/module-user.extended.model';
import { ModuleUser } from 'app/library/module-user/models/module-user.model';
import { IUnbookProgramExecutionUsersActionPayload } from '../interfaces/program-execution-unbook-users-action.action-payload.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { INotifyAllParticipantsActionPayload } from 'app/library/module/interfaces/notfiy-all.action.interface';
import { INotifySelectedParticipantsActionPayload } from 'app/library/module/interfaces/notfiy-selected.action.interface';
import { IParticipantBookingActionPayload } from '../interfaces/participant-booking-action.action-payload.interface';
import { ParticipantBooking } from '../models/participant-booking.model';
import { INotifyFitlersActionPayload } from 'app/library/module/interfaces/notfiy-filters.action.interface';
import { User } from 'app/projects/user/src/lib/models/user';

export class SetCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] SetCourseOfferingParticipants';

    constructor(public payload: ModuleUserExtended[]) {}
}

export class UnsetCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] UnsetCourseOfferingParticipants';
}

export class FetchCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingParticipants';

    constructor(
        public payload?: {
            courseOfferingId: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            withoutCertificate?: boolean;
            selectedCertificateIds?: string[];
            selectedStatusIds?: string[];
            selectedExecutionIds?: string[];
            dateRangeFilters?: IModuleUserDateRangeFilters;
            audienceIds?: string[];
            teamIds?: string[];
            extendedAttributesFilters?: ExtendedAttributeFilterInterface[];
            isUnassignedSelectedAudiences?: boolean;
            isUnassignedSelectedTeams?: boolean;
            excludedTeamIds?: string[];
            teamRoleIds?: string[];
            columns?: string[];
        }
    ) {}
}

export class FetchCourseOfferingParticipantsSuccess {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingParticipantsSuccess';
}

export class FetchCourseOfferingParticipantsFailure {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingParticipantsFailure';
}

export class FetchProgramExecutionCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] FetchProgramExecutionCourseOfferingParticipants';

    constructor(
        public payload?: {
            courseOfferingId: string;
            programExecutionId: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            withoutCertificate?: boolean;
            selectedCertificateIds?: string[];
            selectedStatusIds?: string[];
            selectedExecutionIds?: string[];
            dateRangeFilters?: IModuleUserDateRangeFilters;
            audienceIds?: string[];
            teamIds?: string[];
            extendedAttributesFilters?: ExtendedAttributeFilterInterface[];
            isUnassignedSelectedAudiences?: boolean;
            isUnassignedSelectedTeams?: boolean;
            excludedTeamIds?: string[];
            teamRoleIds?: string[];
            columns?: string[];
        }
    ) {}
}

export class ToggleSelectedParticipants {
    static readonly type = '[CourseOfferingParticipants] ToggleSelectedParticipants';

    constructor(public payload: string) {}
}

export class SelectFilteredParticipants {
    static readonly type = '[CourseOfferingParticipants] SelectFilteredParticipants';
}

export class DeselectSelectedFilteredParticipants {
    static readonly type = '[CourseOfferingParticipants] DeselectSelectedFilteredParticipants';
}

export class FetchProgramExecutionCourseOfferingParticipantsSuccess {
    static readonly type = '[CourseOfferingParticipants] FetchProgramExecutionCourseOfferingParticipantsSuccess';
}

export class FetchProgramExecutionCourseOfferingParticipantsFailure {
    static readonly type = '[CourseOfferingParticipants] FetchProgramExecutionCourseOfferingParticipantsFailure';
}

export class FetchCourseOfferingParticipant {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingParticipant';

    constructor(public payload: { moduleId: string; userId: string }) {}
}

export class FetchCourseOfferingParticipantSuccess {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingParticipantSuccess';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchCourseOfferingParticipantFailure {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingParticipantFailure';

    constructor() {}
}

export class FetchCourseOfferingAssignedCertificates {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingAssignedCertificates';

    constructor(public payload: { programExecutionId: string; courseOfferingId: string }) {}
}

export class FetchCourseOfferingAssignedCertificatesSuccess {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingAssignedCertificatesSuccess';

    constructor(public payload: SimpleCertificate[]) {}
}

export class FetchCourseOfferingAssignedCertificatesFailure {
    static readonly type = '[CourseOfferingParticipants] FetchCourseOfferingAssignedCertificatesFailure';

    constructor() {}
}

export class UnbookParticipant {
    static readonly type = '[CourseOfferingParticipants] UnbookParticipant';

    constructor(public payload: IUnbookProgramExecutionUsersActionPayload) {}
}

export class UnbookParticipantSuccess {
    static readonly type = '[CourseOfferingParticipants] UnbookParticipantSuccess';

    constructor() {}
}

export class UnbookParticipantFailure {
    static readonly type = '[CourseOfferingParticipants] UnbookParticipantFailure';
}

export class UnbookManager {
    static readonly type = '[CourseOfferingParticipants] UnbookManager';

    constructor(public payload: IUnbookProgramExecutionUsersActionPayload) {}
}

export class UnbookManagerSuccess {
    static readonly type = '[CourseOfferingParticipants] UnbookManagerSuccess';

    constructor() {}
}

export class UnbookManagerFailure {
    static readonly type = '[CourseOfferingParticipants] UnbookManagerFailure';
}

export class SearchCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] SearchCourseOfferingParticipants';

    constructor(
        public payload: {
            searchTerm: string;
            source?: string;
        }
    ) {}
}

export class SortCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] SortCourseOfferingParticipants';

    constructor(public payload: Sort) {}
}

export class NotifyAllProgramExecutionCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] NotifyAllProgramExecutionCourseOfferingParticipants';

    constructor(
        public payload: { programExecutionId: string; courseOfferingId: string; notifyAll: INotifyAllParticipantsActionPayload; notifyFilters?: INotifyFitlersActionPayload }
    ) {}
}

export class NoNotifyAllProgramExecutionCourseOfferingParticipantsSuccess {
    static readonly type = '[CourseOfferingParticipants] NoNotifyAllProgramExecutionCourseOfferingParticipantsSuccess';
}

export class NotifyAllProgramExecutionCourseOfferingParticipantsFailure {
    static readonly type = '[CourseOfferingParticipants] NotifyAllProgramExecutionCourseOfferingParticipantsFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class NotifySelectedProgramExecutionCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] NotifySelectedProgramExecutionCourseOfferingParticipants';

    constructor(
        public payload: {
            programExecutionId: string;
            courseOfferingId: string;
            notifySelected: INotifySelectedParticipantsActionPayload;
            notifyFilters?: INotifyFitlersActionPayload;
        }
    ) {}
}

export class NotifySelectedProgramExecutionCourseOfferingParticipantsSuccess {
    static readonly type = '[CourseOfferingParticipants] NotifySelectedProgramExecutionCourseOfferingParticipantsSuccess';
}

export class NotifySelectedProgramExecutionCourseOfferingParticipantsFailure {
    static readonly type = '[CourseOfferingParticipants] NNotifySelectedProgramExecutionCourseOfferingParticipantsFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class NotifyAllCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] NotifyAllCourseOfferingParticipants';

    constructor(public payload: { courseOfferingId: string; notifyAll: INotifyAllParticipantsActionPayload; notifyFilters?: INotifyFitlersActionPayload }) {}
}

export class NoNotifyAllCourseOfferingParticipantsSuccess {
    static readonly type = '[CourseOfferingParticipants] NoNotifyAllCourseOfferingParticipantsSuccess';
}

export class NotifyAllCourseOfferingParticipantsFailure {
    static readonly type = '[CourseOfferingParticipants] NotifyAllCourseOfferingParticipantsFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class NotifySelectedCourseOfferingParticipants {
    static readonly type = '[CourseOfferingParticipants] NotifySelectedCourseOfferingParticipants';

    constructor(public payload: { courseOfferingId: string; notifySelected: INotifySelectedParticipantsActionPayload; notifyFilters?: INotifyFitlersActionPayload }) {}
}

export class NotifySelectedCourseOfferingParticipantsSuccess {
    static readonly type = '[CourseOfferingParticipants] NotifySelectedCourseOfferingParticipantsSuccess';
}

export class NotifySelectedCourseOfferingParticipantsFailure {
    static readonly type = '[CourseOfferingParticipants] NotifySelectedCourseOfferingParticipantsFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class FetchProgramParticipantBookings {
    static readonly type = '[CourseOfferingParticipants] FetchProgramParticipantBookings';

    constructor(public payload: IParticipantBookingActionPayload) {}
}

export class FetchProgramParticipantBookingsSuccess {
    static readonly type = '[CourseOfferingParticipants] FetchProgramParticipantBookingsSuccess';

    constructor(public payload: ParticipantBooking[]) {}
}

export class FetchProgramParticipantBookingsFailure {
    static readonly type = '[CourseOfferingParticipants] FetchProgramParticipantBookingsFailure';
}

export class FetchProgramManagerBookings {
    static readonly type = '[CourseOfferingParticipants] FetchProgramManagerBookings';

    constructor(public payload: IParticipantBookingActionPayload) {}
}

export class FetchProgramManagerBookingsSuccess {
    static readonly type = '[CourseOfferingParticipants] FetchProgramManagerBookingsSuccess';

    constructor(public payload: ParticipantBooking[]) {}
}

export class FetchProgramManagerBookingsFailure {
    static readonly type = '[CourseOfferingParticipants] FetchProgramManagerBookingsFailure';
}
